module.exports = __webpack_public_path__ + "img/LunaJoyasLogo.86fcef73.png";